module.exports = __webpack_public_path__ + "background.png?09ddde318c7f278170aaef124f979552";